"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation, useQueryClient } from "@packages/sdk";

import { keyMeRelatedAccounts } from "./useRequestMeRelatedAccounts";

const urlBackendPath = "/register/kids" as const;

export const useRequestRegisterKidsPost = ({
  onSuccess,
  ...props
}: Partial<UseOpenApiMutationOptions<typeof urlBackendPath, "POST">> = {}) => {
  const queryClient = useQueryClient();

  return useOpenApiMutation({
    method: "POST",
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: keyMeRelatedAccounts() });
      onSuccess?.(data, variables, context);
    },
    urlBackendPath,
    ...props,
  });
};
